<template>
  <el-form class="global-form-com" ref="form" :model="form" v-bind="formConfig">
    <el-row
      class="row-box"
      v-for="(row, index) in formData"
      :key="index"
      v-bind="row.rowProps"
    >
      <el-row v-bind="row.rowItemProps" class="row-content">
        <el-col v-for="col in row.cols" :key="col.key" v-bind="col.colProps">
          <el-form-item v-if="!col.hidden" v-bind="col.formItemProps">
            <!-- <slot v-if="col.type === 'slot'" :name="col.key" :row="row"></slot> -->
            <component
              v-if="col.type === 'component'"
              :is="col.componentName"
              v-bind="col"
              :form="form"
            ></component>
            <el-select
              v-else-if="col.type === 'el-select-tree'"
              :ref="`select_${col.key}`"
              popper-class="custom-select-tree"
              :style="{ width: selectOptionWidth }"
              v-model="form[col.key]"
              v-bind="col.itemProps || {}"
              v-on="col.itemEvents || {}"
              @focus="setOptionWidth"
            >
              <el-option :value="form[col.key]" :label="col.treeLabel">
                <el-tree
                  :ref="`select_tree_${col.key}`"
                  v-bind="col.treeProps"
                  @node-click="handleNodeClick($event, col)"
                >
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <GlobalAutoTooltip
                      :content="node.label"
                      placement="right"
                    />
                  </span>
                </el-tree>
              </el-option>
            </el-select>
            <el-select
              v-else-if="col.type === 'el-select'"
              :style="{ width: selectOptionWidth }"
              v-model="form[col.key]"
              v-bind="col.itemProps || {}"
              v-on="col.itemEvents || {}"
              @focus="setOptionWidth"
            >
              <el-option
                :label="option[col.labelKey || 'label']"
                :value="option[col.valueKey || 'value']"
                v-for="option in col.options"
                :key="option[col.valueKey || 'value']"
              ></el-option>
            </el-select>
            <el-checkbox
              v-else-if="col.type === 'el-checkbox'"
              v-model="form[col.key]"
              v-bind="col.itemProps || {}"
              v-on="col.itemEvents || {}"
              >{{ col.name }}</el-checkbox
            >
            <el-radio-group
              v-else-if="col.type === 'el-radio-group'"
              v-model="form[col.key]"
              v-bind="col.itemProps || {}"
              v-on="col.itemEvents || {}"
            >
              <el-radio
                v-for="option in col.options"
                v-model="form[col.key]"
                :key="option[col.valueKey || 'value']"
                :label="option[col.labelKey || 'value']"
                :data-label="option[col.labelKey || 'value']"
                >{{ option.name }}</el-radio
              >
            </el-radio-group>
            <el-cascader
              v-else-if="col.type === 'el-cascader'"
              v-model="form[col.key]"
              v-bind="col.itemProps || {}"
              :options="col.options"
              :props="{ label: 'name', value: 'id', children: 'children' }"
              @change="handleChange"
            ></el-cascader>
            <el-input-number
              v-else-if="col.type === 'el-input-number'"
              v-model="form[col.key]"
              v-bind="col.itemProps || {}"
              v-on="col.itemEvents || {}"
            ></el-input-number>
            <el-upload
              class="custom-upload"
              :ref="`upload_${col.key}`"
              v-else-if="col.type === 'el-upload'"
              v-model="form[col.key]"
              v-bind="col.itemProps || {}"
              v-on="col.itemEvents || {}"
              :before-upload="(file) => beforeUpload(file, col)"
              :on-exceed="(file, fileList) => handleExceed(file, fileList, col)"
              :action="$baseUrl + '/api/common/upload?token=' + token"
              :on-error="($event) => handleError($event, col)"
              :on-success="
                ($event, file, fileList) =>
                  handleSuccess($event, file, fileList, col)
              "
            >
              <el-button
                v-if="col.showUploadBtn"
                v-bind="col.uploadBtnProps || { size: 'mini', type: 'primary' }"
                slot="trigger"
                >上传</el-button
              >
              <!-- <img
                v-if="col.showImage && form[col.key]"
                :src="$baseUrl + form[col.key]"
                class="avatar"
              /> -->
              <div class="file-list-wrap">
                <span
                  class="file-list-item"
                  v-for="(item, index) in col.fileList"
                  :key="item.url"
                >
                  <el-image
                    v-if="col.showImage"
                    :src="$baseUrl + item.url"
                    class="upload-image-item"
                  >
                    <!-- 上传图片预览 -->
                    <!-- :preview-src-list="col.fileList.map((item) => item.url)" -->
                  </el-image>
                  <div class="upload-file-item" v-else-if="col.showFiles">
                    <i
                      :class="[
                        col.fileIconClass || 'el-icon-document',
                        'upload-icon-item',
                      ]"
                    ></i>
                    <GlobalAutoTooltip :content="item.name" placement="right" />
                  </div>
                  <span v-else class="flex-1 w0 ml-10" style="text-align: left"
                    ><GlobalAutoTooltip
                      :content="col.fileList"
                      placement="right"
                  /></span>
                  <i
                    class="el-icon-delete icon-pointer"
                    @click="deleteUrl(index, col)"
                  ></i>
                </span>
              </div>

              <!-- <div slot="tip"
                 class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>
            <el-input
              v-else-if="col.type === 'el-input'"
              v-model="form[col.key]"
              v-bind="col.itemProps || {}"
              v-on="col.itemEvents || {}"
            ></el-input>
            <!-- <el-autocomplete
              v-else-if="col.type === 'el-autocomplete'"
              v-model="form[col.key]"
              v-bind="col.itemProps || {}"
              v-on="col.itemEvents || {}"
              :fetch-suggestions="querySearch"
              @select="handleSelect"
            ></el-autocomplete> -->
            <el-image
              v-else-if="col.type === 'el-image'"
              :src="$baseUrl + form[col.key]"
              v-bind="col.itemProps || {}"
              v-on="col.itemEvents || {}"
            ></el-image>
            <el-date-picker
              v-else-if="col.type === 'el-date-picker'"
              v-model="form[col.key]"
              v-bind="col.itemProps || {}"
              v-on="col.itemEvents || {}"
            >
            </el-date-picker>
            <div v-else-if="col.type === 'text'">{{ form[col.key] }}</div>
            <a
              class="download-btn"
              v-else-if="col.type === 'download'"
              :download="form[col.key]"
              :href="form[col.key]"
              >下载</a
            >

            <div class="unit-box" v-if="col.unit" :name="col.key">
              {{ col.unit }}
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-row>
    <slot name="footer"></slot>
  </el-form>
</template>

<script>
import extendComponents from "../extend/index";
// import debounce from "@/utils/debounce";
// import { getCharge } from "@/api/team";

export default {
  components: {
    ...extendComponents,
  },
  // mixins: [extend],
  props: {
    formConfig: {
      type: Object,
      default() {
        return {};
      },
    },
    formData: {
      type: Array,
      default() {
        return [];
      },
    },
    form: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      selectOptionWidth: "auto",
      token: "",
      // restaurants: [],
    };
  },
  created() {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    // const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (userInfo) {
      this.token = userInfo.token;
    }
  },
  methods: {
    setOptionWidth(event) {
      // 下拉框弹出时，设置弹框的宽度
      this.$nextTick(() => {
        this.selectOptionWidth = event.srcElement.offsetWidth + "px";
      });
    },
    handleNodeClick(data, col) {
      this.$set(this.form, [col.key], data.id);
      col.treeLabel = data[col.treeProps.props.label];
      this.$refs[`select_${col.key}`][0].blur();
    },
    setDefaultUploadFiles(col) {
      this.$refs[`upload_${col.key}`][0].uploadFiles = col.fileList;
    },
    beforeUpload(file, col) {
      if (col.itemProps.accept) {
        const ext = col.itemProps.accept;
        const fileExt = file.name.split(".").pop().toLowerCase();

        if (ext.indexOf(fileExt) == -1) {
          this.$message.warning(`请上传${ext}格式的文件`);
          return false;
        }
      }
    },
    handleSuccess(res, file, fileList, col) {
      if (res.code == 1) {
        //push 上传图片
        col.fileList = fileList.map((item) => {
          return {
            url: item.url || item.response.data.url,
            name: item.name,
            uid: item.uid,
          };
        });
        this.$set(this.form, [col.key], col.fileList);
        this.$refs.form.validateField(col.key); // 手动触发fileList校验规则
      } else {
        const index = fileList.findIndex((item) => item.uid == file.uid);
        fileList.splice(index, 1);
      }
      // this.$refs.`upload`[0] && this.$refs.`upload`[0].clearFiles();
      this.$message({
        message: res.msg,
        type: res.code == 1 ? "success" : "error",
        duration: 1500,
      });
    },
    handleError(err, col) {
      console.log(
        "🚀 ~ file: CustomForm.vue ~ line 179 ~ handleError ~ err, col",
        err,
        col
      );
      const error = JSON.parse(err.message);
      this.$refs[`upload_${col.key}`][0] &&
        this.$refs[`upload_${col.key}`][0].clearFiles();
      const that = this;
      that.$message({
        message: error.msg,
        type: "error",
        duration: 1500,
        // onClose: function() {
        //   that.$router.push('/login')
        // }
      });
    },
    deleteUrl(index, col) {
      this.$refs[`upload_${col.key}`][0].uploadFiles.splice(index, 1);
      col.fileList.splice(index, 1);
      this.$set(this.form, [col.key], [...col.fileList]);
    },
    handleExceed(files, fileList, col) {
      this.$message.warning(
        `当前限制选择 ${col.itemProps.limit} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    handleChange() {},
    // querySearch: debounce(function (queryString, cb) {
    //   getCharge({nickname:queryString}).then((res) => {
    //     cb(res.data);
    //   });
    // }, 1000),
    // handleSelect(item) {
    //   console.log(item);
    //   //回调nameChane
    //   this.$emit("nameChange", item);
    // },
  },
};
</script>

<style lang="scss">
$baseHeight: 40;
.global-form-com {
  padding-bottom: 0.3rem;
  .el-row--flex {
    flex-wrap: wrap;
  }

  .row-box {
    &:first-child {
      border-top: none;
    }
  }

  .custom-datetime {
    position: absolute !important;
    left: 0 !important;
    top: px2vh(40) !important;
  }

  .file-list-wrap {
    margin-left: 0.1rem;
    @include flex(row, flex-start, center);
    flex-wrap: wrap;

    .file-list-item {
      @include flex(row, center, flex-end);
      margin: 0 0.1rem;
    }

    .upload-image-item {
      width: 0.8rem;
      height: 0.8rem;

      img {
        object-fit: cover;
      }
    }

    .el-icon-delete {
      color: red;
    }

    .upload-file-item {
      width: 0.8rem;
      height: 0.8rem;
      @include flex(column, space-between, center);

      .upload-icon-item {
        font-size: 0.4rem;
      }

      .el-tooltip {
        width: 100%;
        line-height: 1.2;
      }
    }
  }

  .el-form-item {
    // margin: px2vh(10) 0.4rem 0.2rem 0.1rem;
    margin: px2vh(10);

    // background-color: rgba(33, 166, 154, 0.1);
    padding: 0;
    box-sizing: border-box;
    border-radius: px2vh(4);
  }
  .el-form-item__label {
    @include font4vh(#505887, 14, 400);
    height: px2vh($baseHeight);
    font-size: 0.12rem;
    line-height: px2vh($baseHeight);
    padding-right: px2vh(10);
  }

  .el-form-item__content {
    line-height: px2vh($baseHeight);
    display: flex;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: transparent;
    border-color: rgba(203, 224, 255, 0.5);
  }

  .el-form-item__content {
    .el-input__inner {
      border-radius: px2vh(6);
      // border-top: 1px solid rgba(255, 255, 255, 0.5);
      border-color: #dfeaf2;
      background-size: 100% 100%;
      @include font4vh(#000, 14, 400);
      background-color: transparent;
      // height: px2vh($baseHeight) !important;
      line-height: px2vh($baseHeight);

      &::placeholder {
        color: #bbbbbb;
      }
    }

    .el-textarea {
      @include font4vh(#000, 14, 400);
    }
    .el-textarea__inner {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      &::placeholder {
        @include font4vh(#bbbbbb, 14, 400);
      }
    }

    .el-select .el-tag {
      padding: 0 px2vh(8);
      margin: px2vh(4);
      height: px2vh(28);
      line-height: px2vh(28);
    }

    .el-input__icon {
      line-height: px2vh($baseHeight);
    }
    .el-select,
    .el-date-editor.el-input,
    .el-date-editor--daterange.el-input__inner {
      width: 100% !important;
      // height: px2vh($baseHeight);
    }
    .el-date-editor--daterange.el-input__inner {
      padding: 0;
      border: none;
      @include font4vh(#fff, 14, 400);
    }

    .el-date-editor .el-range-separator {
      @include font4vh(#fff, 14, 400);
      line-height: px2vh($baseHeight);
    }

    .el-range-input {
      background-color: transparent;
      @include font4vh(#fff, 14, 400);
    }

    .el-select__input {
      @include font4vh(#fff, 14, 400);
    }

    .el-textarea__inner {
      @include font4vh(#000, 14, 400);
      background-color: transparent;
      border-color: rgba(203, 224, 255, 0.5);
      &::-webkit-scrollbar {
        display: none !important; /* Chrome Safari */
      }
    }

    .el-input__count {
      background: transparent;
      bottom: 0;
      @include font4vh(rgba(168, 214, 255, 0.5), 14, 400);
    }

    // .el-date-editor .el-range__icon {
    // }
  }

  .has-unit {
    .el-input__inner {
      padding-right: px2vh(30);
    }
  }

  .has-unit2 {
    .el-input__inner {
      padding-right: px2vh(40);
    }
  }

  .download-btn {
    color: rgb(1, 194, 255);
    cursor: pointer;
  }

  .el-upload {
    @include flex(row, flex-start, center);
  }

  .custom-upload {
    width: 100%;
    // height: px2vh($baseHeight);
    // display: flex;
    // align-items: center;
    .el-upload {
      height: px2vh($baseHeight);
    }
  }

  .el-upload-list {
    display: none;
  }

  .avatar {
    margin-left: px2vh(10);
    height: px2vh(40);
  }

  .unit-box {
    position: absolute;
    right: px2vh(10);
    top: 0;
    @include font4vh(rgba(203, 224, 255, 1), 14, 400);
  }
}
</style>
